import styled from "styled-components";

const Content = styled.p`
  padding: 20px;
  border-radius: 5px;
  font-size: 20px;
  font-family: "Amsterdam";
`;
export default Content;
